import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/lib/utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-primary text-onColor hover:bg-primary-hover disabled:bg-disabled disabled:text-disabled',
        secondary: 'bg-secondary hover:bg-secondary-hover disabled:bg-disabled disabled:text-disabled',
        destructive:
          'bg-error-strong text-onColor hover:bg-error-strong-hover disabled:bg-disabled disabled:text-disabled',
        outline: 'border hover:bg-elevated hover:border-hover disabled:border-disabled disabled:text-disabled ',
        ghost: 'hover:bg-elevated disabled:border-disabled disabled:text-disabled',
        link: 'text-interactive hover:underline hover:underline-offset-4 disabled:text-disabled',
        ghostIcon: 'disabled:border-disabled disabled:text-disabled',
      },
      size: {
        default: 'h-10 px-4 py-2 text-sm shadow-sm',
        sm: 'h-9 px-4 py-2 text-sm shadow-sm',
        lg: 'h-11 px-4 py-2 text-base shadow-sm',
        xl: 'h-12 px-4 py-3 text-base shadow-sm',
        icon: 'h-9 w-9 shadow-sm',
        ghostIcon: 'h-9 w-9',
        ghostSmall: 'px-3 py-2.5 shadow-none rounded-none',
        link: 'px-4 py-2 text-sm shadow-none',
      },
      wrap: {
        default: 'whitespace-nowrap',
        normal: 'whitespace-normal',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      wrap: 'default',
    },
  }
);

const Button = React.forwardRef(({ className, variant, size, wrap, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return <Comp className={cn(buttonVariants({ variant, size, wrap, className }))} ref={ref} {...props} />;
});
Button.displayName = 'Button';

export { Button, buttonVariants };
